const imageFileType = '.webp, .jpg, .jpeg, .png, .gif' as const;
const videoFileType = '.mp4, .mov, .avi, .wmv' as const;

export { imageFileType, videoFileType };
